import axios from 'axios';
import { API } from './utils';

// Offline-resilient failed check-in logging.
// Failed attempts are queued in localStorage on the tablet and synced to the
// backend whenever a connection is available, so the admin can see WHO failed
// to check in, WHEN and WHY — even if the tablet was offline at the time.

const STORAGE_KEY = 'failed_checkin_logs';

function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

function writeQueue(logs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(-100)));
  } catch (e) {
    // localStorage unavailable/full — nothing more we can do
  }
}

export function logFailedCheckin({ employeeNumber, employeeName, roomNumber, reason, detail }) {
  const logs = readQueue();
  logs.push({
    id: window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    employee_number: employeeNumber || '',
    employee_name: employeeName || '',
    room_number: roomNumber || '',
    attempted_at: new Date().toISOString(),
    reason: reason || 'Unknown',
    detail: detail || '',
  });
  writeQueue(logs);
  // Attempt an immediate sync (works right away for validation failures while online)
  syncFailedCheckinLogs();
}

let syncing = false;

export async function syncFailedCheckinLogs() {
  if (syncing) return;
  const logs = readQueue();
  if (!logs.length) return;
  syncing = true;
  try {
    await axios.post(`${API}/failed-checkins/sync`, { logs }, { timeout: 10000 });
    // Remove only the entries we just synced — new ones may have been queued meanwhile
    const syncedIds = new Set(logs.map((l) => l.id));
    writeQueue(readQueue().filter((l) => !syncedIds.has(l.id)));
  } catch (e) {
    // Still offline or backend unreachable — queue stays, will retry later
  } finally {
    syncing = false;
  }
}
